import React, { FunctionComponent } from "react";
import styled, { css } from "styled-components";

export type DropZoneContainerType = "clearView" | "informativeView" | "transparentView";

interface DropZoneContainerProps {
  type: DropZoneContainerType;
  isDragActive: boolean;
  children: React.ReactNode;
}

/**
 * Based on required type, returns the requested wrapper for dropzone
 */
export const DropZoneContainer: FunctionComponent<DropZoneContainerProps> = ({
  type,
  isDragActive,
  children
}) => {
  switch (type) {
    case "clearView": {
      return (
        <ClearViewWrapper isDragActive={isDragActive}>
          {children}
        </ClearViewWrapper>
      );
    }
    case "informativeView": {
      return (
        <InformativeViewWrapper isDragActive={isDragActive}>
          {children}
        </InformativeViewWrapper>
      );
    }
    case "transparentView": {
      return (
        <TransparentViewWrapper isDragActive={isDragActive}>
          {children}
        </TransparentViewWrapper>
      );
    }
    default: {
      console.error("Error, DropZoneContainer expects valid type");

      return null;
    }
  }
};

const TransparentViewWrapper = styled.div<{ isDragActive: boolean }>`
  ${({ theme, isDragActive }) => css `
    text-align: inherit;
    padding: ${theme.spacing.padding.md};
    border: dashed ${isDragActive ? "2px" : "0"} ${theme.colors.accentLight};
    border-radius: 4px;
    box-sizing: border-box;
  `}
`;

const ClearViewWrapper = styled.div<{ isDragActive: boolean }>`
  ${({ theme, isDragActive }) => css `
    text-align: center;
    padding: 50px ${theme.spacing.padding.md};
    border: dashed 2px ${isDragActive ? theme.colors.accentLight : theme.colors.primaryLight};
    border-radius: 4px;
    box-sizing: border-box;
  `}
`;

const InformativeViewWrapper = styled.div<{ isDragActive: boolean }>`
  ${({ theme, isDragActive }) => css `
    text-align: inherit;
    padding: ${theme.spacing.padding.md};
    border: ${isDragActive ? `dashed 2px ${theme.colors.accentLight}` : `solid 1px ${theme.colors.primaryDark}`};
    border-radius: 4px;
    box-sizing: border-box;
  `}
`;

export default DropZoneContainer;